import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.parse-int";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SET_CLASS_ID = 'classpass/inventoryDetail/SET_CLASS_ID';
var SET_CLASS_MOVEMENT_SERP_LINKS = 'classpass/inventoryDetail/SET_CLASS_MOVEMENT_SERP_LINKS';
var SET_DYNAMIC_TAGS_INFO = 'classpass/inventoryDetail/SET_DYNAMIC_TAGS_INFO';
var SET_SCHEDULE_ID = 'classpass/inventoryDetail/SET_SCHEDULE_ID';
var SET_STUDIO_ACTIVITY_SERP_LINKS = 'classpass/inventoryDetail/SET_STUDIO_ACTIVITY_SERP_LINKS';
var SET_STUDIO_LOCATION_SERP_LINK = 'classpass/inventoryDetail/SET_STUDIO_LOCATION_SERP_LINK';
var SET_STUDIO_TAG_SERP_LINKS = 'classpass/inventoryDetail/SET_STUDIO_TAG_SERP_LINKS';
var SET_VENUE_ID = 'classpass/inventoryDetail/SET_VENUE_ID';
var SET_VENUE_SCHEDULE_EXPANDED = 'classpass/inventoryDetail/SET_VENUE_SCHEDULE_EXPANDED';
export var SET_VENUE_SCHEDULE_DATE = 'classpass/inventoryDetail/SET_VENUE_SCHEDULE_DATE';
var initialState = {
  activitySerpLinks: [],
  classId: 0,
  dynamicTagsInfo: {},
  locationSerpLink: null,
  movementSerpLinks: [],
  msaId: 0,
  scheduleExpanded: false,
  scheduleId: 0,
  tagSerpLinks: [],
  venueId: 0,
  venueScheduleDate: ''
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case SET_CLASS_ID:
    case SET_CLASS_MOVEMENT_SERP_LINKS:
    case SET_DYNAMIC_TAGS_INFO:
    case SET_SCHEDULE_ID:
    case SET_STUDIO_ACTIVITY_SERP_LINKS:
    case SET_STUDIO_LOCATION_SERP_LINK:
    case SET_STUDIO_TAG_SERP_LINKS:
    case SET_VENUE_ID:
    case SET_VENUE_SCHEDULE_DATE:
    case SET_VENUE_SCHEDULE_EXPANDED:
      return _objectSpread({}, state, payload);

    default:
      return state;
  }
}
export var setActivitySerpLinks = function setActivitySerpLinks(activitySerpLinks) {
  return {
    type: SET_STUDIO_ACTIVITY_SERP_LINKS,
    activitySerpLinks: activitySerpLinks
  };
};
export var setClassId = function setClassId(classId) {
  return {
    type: SET_CLASS_ID,
    classId: parseInt(classId, 10)
  };
};
export var setDynamicTagsInfo = function setDynamicTagsInfo(dynamicTagsInfo) {
  return {
    type: SET_DYNAMIC_TAGS_INFO,
    dynamicTagsInfo: dynamicTagsInfo
  };
};
export var setLocationSerpLink = function setLocationSerpLink(locationSerpLink) {
  return {
    type: SET_STUDIO_LOCATION_SERP_LINK,
    locationSerpLink: locationSerpLink
  };
};
export var setMovementSerpLinks = function setMovementSerpLinks(movementSerpLinks) {
  return {
    type: SET_CLASS_MOVEMENT_SERP_LINKS,
    movementSerpLinks: movementSerpLinks
  };
};
export var setScheduleId = function setScheduleId(scheduleId) {
  return {
    type: SET_SCHEDULE_ID,
    scheduleId: parseInt(scheduleId, 10)
  };
};
export var setTagSerpLinks = function setTagSerpLinks(tagSerpLinks) {
  return {
    type: SET_STUDIO_TAG_SERP_LINKS,
    tagSerpLinks: tagSerpLinks
  };
};
export var setVenueId = function setVenueId(venueId) {
  return {
    type: SET_VENUE_ID,
    venueId: parseInt(venueId, 10)
  };
};
export var setVenueScheduleDate = function setVenueScheduleDate(venueScheduleDate) {
  return {
    type: SET_VENUE_SCHEDULE_DATE,
    venueScheduleDate: venueScheduleDate
  };
};
export var setVenueScheduleExpanded = function setVenueScheduleExpanded(scheduleExpanded) {
  return {
    type: SET_VENUE_SCHEDULE_EXPANDED,
    scheduleExpanded: scheduleExpanded
  };
};
export var selectClassId = function selectClassId(state) {
  return state.features.inventoryDetail.classId;
};
export var selectDynamicTagsInfo = function selectDynamicTagsInfo(state) {
  return state.features.inventoryDetail.dynamicTagsInfo;
};
export var selectScheduleId = function selectScheduleId(state) {
  return state.features.inventoryDetail.scheduleId;
};
export var selectVenueId = function selectVenueId(state) {
  return state.features.inventoryDetail.venueId;
};
export var selectVenueScheduleDate = function selectVenueScheduleDate(state) {
  return state.features.inventoryDetail.venueScheduleDate;
};